export default "__VITE_ASSET__B1rq6O8j__"